export default __webpack_public_path__ + "static/media/Start-here.7459bfd0.svg";